import { render } from "./votingDetail.vue?vue&type=template&id=0da38124"
import script from "./votingDetail.vue?vue&type=script&lang=js"
export * from "./votingDetail.vue?vue&type=script&lang=js"

import "./votingDetail.vue?vue&type=style&index=0&id=0da38124&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__